<template>
  <div>
    <el-form-item label="文件名" prop="content.fileName">
      <el-input v-model="modelValue.fileName" placeholder="请输入导出文件名" />
    </el-form-item>
    
    <el-form-item label="组织ID" prop="content.orgId">
      <el-input-number v-model="modelValue.orgId" :min="1" placeholder="请输入组织ID" />
    </el-form-item>

    <el-form-item label="字段映射">
      <div v-for="(value, key) in modelValue.titleMap" :key="key" class="title-map-item">
        <el-input v-model="modelValue.titleMap[key]" placeholder="请输入显示名称">
          <template #prepend>{{ key }}</template>
        </el-input>
        <el-button type="danger" @click="removeTitleMap(key)">删除</el-button>
      </div>
      <div class="add-title-map">
        <el-input v-model="newTitleKey" placeholder="字段名" style="width: 120px" />
        <el-input v-model="newTitleValue" placeholder="显示名称" style="width: 120px" />
        <el-button type="primary" @click="addTitleMap">添加映射</el-button>
      </div>
    </el-form-item>

    <el-form-item label="SQL语句" prop="content.sql">
      <el-input 
        v-model="modelValue.sql" 
        type="textarea" 
        :rows="5" 
        placeholder="请输入SQL语句"
      />
    </el-form-item>

    <el-form-item label="钉钉Webhook" prop="content.webHookUrl">
      <el-input v-model="modelValue.webHookUrl" placeholder="请输入钉钉机器人Webhook地址" />
    </el-form-item>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const newTitleKey = ref('')
    const newTitleValue = ref('')

    const addTitleMap = () => {
      if (newTitleKey.value && newTitleValue.value) {
        emit('update:modelValue', {
          ...props.modelValue,
          titleMap: {
            ...props.modelValue.titleMap,
            [newTitleKey.value]: newTitleValue.value
          }
        })
        newTitleKey.value = ''
        newTitleValue.value = ''
      }
    }

    const removeTitleMap = (key) => {
      const newTitleMap = { ...props.modelValue.titleMap }
      delete newTitleMap[key]
      emit('update:modelValue', {
        ...props.modelValue,
        titleMap: newTitleMap
      })
    }

    return {
      newTitleKey,
      newTitleValue,
      addTitleMap,
      removeTitleMap
    }
  }
}
</script>

<style scoped>
.title-map-item {
  display: flex;
  margin-bottom: 10px;
}
.title-map-item .el-input {
  margin-right: 10px;
}
.add-title-map {
  display: flex;
  gap: 10px;
}
</style>
